/**
 *  Rest HTTP Service
 * 
 * @copyright NIIT Technologies Ltd. 2017-18
 */

import { Component, Inject, Injectable } from '@angular/core';
import { Http, Response, Headers, RequestOptions } from '@angular/http';
import { Observable, Subscription } from 'rxjs/Rx';
//
import { BaseService } from './base.service';
import { HTTPService } from './http.service';
import { Event, NotificationType, HTTPMethod, HTTPContentType, BaseResponse } from '../common/base.data';

/**
 *  Rest HTTP Service
 */

export class RestService extends BaseService {
    private httpSubscription: Subscription = null;
    private timer: Observable<any> = null;

    /**
     * Initialize
     */
    constructor(private httpService: HTTPService) {
        super();
    }

    /**
     * Gets Data (Async)
     * 
     * @param url URL
     * @param data Data
     */
    public getRestData(url: string, data: string): Observable<BaseResponse> {
        return this.httpService.getHTTPData(url, HTTPContentType.JSON, data);
    }

    /**
     * Post Data (Async)
     * 
     * @param url URL
     * @param data Data
     */
    public postRestData(url: string, data: any): Observable<BaseResponse> {
        return this.httpService.postHTTPData(url, HTTPContentType.JSON, data);
    }

    /**
     * Pull Data from Server (Calls Repeatedly on Certain Interval)
     * 
     * @param url URL
     * @param httpMethod HTTP Method (GET/POST)
     * @param data Data
     * @param thisObject This Object
     * @param interval Repeated Call Interval
     * @param callback Callback Function to be Executed on Success Service Call
     *  (@callback @param dataList Data List)
     */
    public sendRestRepeatedly(url: string, httpMethod: string, data: any, thisObject: any, interval: number, callback: (thisObject: any, data: BaseResponse) => any): void {
        // Unsubscribe HTTP
        if (this.httpSubscription) {
            this.httpSubscription.unsubscribe();
            this.httpSubscription = null;
        }
        //
        this.timer = Observable.timer(1000, 1000 * interval)
            .timeInterval()
            .pluck('interval')
            .take(1440);
        // Request from Server (HTTP Call)
        this.httpSubscription = this.timer.subscribe(t => {
            if (httpMethod.toUpperCase() == HTTPMethod.POST) {
                this.postRestData(url, data).subscribe(data => {
                    callback(thisObject, data);
                });
            } else {
                this.getRestData(url, data).subscribe(data => {
                    callback(thisObject, data);
                });
            }
        });
    }

    /**
     * Destroy Service
     */
    public destroy(): void {
        if (this.httpSubscription) {
            this.httpSubscription.unsubscribe();
            this.httpSubscription = null;
        }
        this.httpService.destroy();
    }
static decorators: DecoratorInvocation[] = [
{ type: Injectable },
];
/** @nocollapse */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
{type: HTTPService, },
];
}
interface DecoratorInvocation {
  type: Function;
  args?: any[];
}
